export enum QrCodeNativeMethods {
  READ = 'READ',
}
